import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface ModalPricingState {
  country: string;
  sellerType: string;
  countryCM: string;
}

const initialState: ModalPricingState = {
  country: "",
  sellerType: "",
  countryCM: "",
};

const modalPricingSlice = createSlice({
  name: "modalPricing",
  initialState,
  reducers: {
    setCountry(state, action: PayloadAction<string>) {
      state.country = action.payload;
    },
    setSellerType(state, action: PayloadAction<string>) {
      state.sellerType = action.payload;
    },
    setCountryCm(state, action: PayloadAction<string>) {
      state.countryCM = action.payload;
    },
  },
});

export const selectCountry = (state: RootState) => state.modalPricing.country;
export const selectCountryCm = (state: RootState) =>
  state.modalPricing.countryCM;
export const selectSellerType = (state: RootState) =>
  state.modalPricing.sellerType;
export const { setCountry, setSellerType, setCountryCm } =
  modalPricingSlice.actions;
export default modalPricingSlice.reducer;
